/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/naming-convention */

import * as yup from 'yup';

// prettier-ignore
const baseEventSchema = yup.object({
  dispensary_id: yup
    .string()
    .required(),
  menu_variant: yup
    .string()
    .required(),
});

// prettier-ignore
const itemSchema = yup.object({
  id: yup
    .string()
    .required(),
  library_product_id: yup
    .string()
    .nullable(),
  library_product_score: yup
    .number()
    .nullable(),
  brand_id: yup
    .string()
    .nullable(),
  parent_brand_id: yup
    .string()
    .nullable(),
})

// prettier-ignore
export const cartItemSchema = itemSchema.shape({
  price: yup
    .number()
    .required(),
  quantity: yup
    .number()
    .required(),
  option: yup
    .string()
    .nullable(),
});

// prettier-ignore
export const placedOrderCartItemSchema = cartItemSchema.shape({
  base_price: yup
    .number()
    .required(),
  discounted_base_price: yup
    .number()
    .nullable(),
  total_price: yup
    .number()
    .required(),
});

const addedProductToCartSchema = baseEventSchema.shape({
  item: cartItemSchema,
});

const removedProductFromCartSchema = baseEventSchema.shape({
  item: cartItemSchema,
});

// prettier-ignore
const placedOrderSchema = baseEventSchema.shape({
  subtotal: yup
    .number()
    .required(),
  total: yup
    .number()
    .required(),
  discount: yup
    .number()
    .required(),
  final_total: yup
    .number()
    .required(),
  items: yup
    .array()
    .of(placedOrderCartItemSchema)
    .required(),
  order_id: yup
    .string()
    .required(),
  payment_method: yup
    .string()
    .required(),
  round_up_the_change_eligible: yup
    .boolean()
    .nullable(),
  round_up_the_change_fee_donation_id: yup
    .number()
    .nullable(),
  round_up_the_change_selected: yup
    .boolean()
    .nullable(),
  round_up_the_change_amount: yup
    .string()
    .nullable(),
});

// prettier-ignore
const searchResultsSchema = baseEventSchema.shape({
  query: yup
    .string()
    .required(),
});

// prettier-ignore
const viewedPageSchema = baseEventSchema.shape({
  pageType: yup
    .string()
});

// prettier-ignore
const viewedProductSchema = baseEventSchema.shape({
  item: itemSchema,
});

const cartViewedSchema = baseEventSchema;

const dutchiePayCTAButtonClickedSchema = baseEventSchema;

const dutchiePayRelinkButtonViewedSchema = baseEventSchema;
const dutchiePayRelinkButtonClickedSchema = baseEventSchema;

// prettier-ignore
const productClickedSchema = baseEventSchema.shape({
  item: itemSchema,
  placement: yup.
    string()
    .nullable(),
  position: yup.
    number()
    .nullable(),
  provider: yup.
    string()
    .nullable(),
});

// prettier-ignore
const trackerItemSchema = yup.object({
  id: yup
    .string()
    .nullable(),
  library_product_id: yup
    .string()
    .nullable(),
  brand_id: yup
    .string()
    .nullable(),
  parent_brand_id: yup
    .string()
    .nullable(),
})

// prettier-ignore
const productTrackerSchema = baseEventSchema.shape({
  tracking_url: yup
    .string()
    .required(),
  position: yup
    .number()
    .nullable(),
  item: trackerItemSchema,
})

// prettier-ignore
const bannerTrackerSchema = baseEventSchema.shape({
  tracking_url: yup
    .string()
    .required(),
  items: yup
    .array()
    .of(trackerItemSchema),
})

const dispensaryClickedSchema = baseEventSchema.shape({
  dispensary_name: yup.string().required(),
  dispensary_address: yup.string().required(),
  dispensary_chain_name: yup.string().required(),
  source: yup.string().required(),
  meta: yup.object().shape({
    product: yup.object().required(),
  }),
});

const baseDeviceTrackingFields = {
  is_kiosk_order: yup.boolean().required(),
  is_hub_order: yup.boolean().required(),
  checkout_token: yup.string().nullable(),
};

const dutchiePayEnrollmentStepSchema = baseEventSchema.shape({
  step: yup.string().required(),
  action: yup.string().required(),
  enrollment_source: yup.string().optional(),
  context: yup.string().optional(),
  ...baseDeviceTrackingFields,
});

const dutchiePayEnrollmentButtonClickedSchema = baseEventSchema.shape({
  button_location: yup.string().required(),
});

const dutchiePayEnrollmentStepCancelledSchema = baseEventSchema.shape({
  step: yup.string().required(),
  ...baseDeviceTrackingFields,
});

const dutchiePayPlaidOnEventSchema = baseEventSchema.shape({
  event_name: yup.string().required(),
  connection_method: yup.string().required(),
  error_code: yup.string().nullable(),
  error_message: yup.string().nullable(),
  institution_id: yup.string().nullable(),
  institution_name: yup.string().nullable(),
  mfa_type: yup.string().nullable(),
  selection: yup.string().nullable(),
  ...baseDeviceTrackingFields,
});

const dutchiePayPlaidOnLoadSchema = baseEventSchema.shape({
  connection_method: yup.string().required(),
  ...baseDeviceTrackingFields,
});

const dutchiePayPlaidOnSuccessSchema = baseEventSchema.shape({
  institution_id: yup.string().nullable(),
  institution_name: yup.string().nullable(),
  connection_method: yup.string().required(),
  ...baseDeviceTrackingFields,
});

const dutchiePayPlaidOnExitSchema = baseEventSchema.shape({
  exit_point: yup.string().nullable().optional(),
  error_code: yup.string().nullable().optional(),
  error_message: yup.string().nullable().optional(),
  institution_id: yup.string().nullable().optional(),
  institution_name: yup.string().nullable().optional(),
  connection_method: yup.string().required(),
  ...baseDeviceTrackingFields,
});

const dutchiePayAeroSyncOnEventSchema = baseEventSchema.shape({
  event_name: yup.string().required(),
  widget_title: yup.string().required(),
  ...baseDeviceTrackingFields,
});

const dutchiePayAeroSyncOnLoadSchema = baseEventSchema.shape({
  ...baseDeviceTrackingFields,
});

const dutchiePayAeroSyncOnCloseSchema = baseEventSchema.shape({
  ...baseDeviceTrackingFields,
});

const dutchiePayAeroSyncOnSuccessSchema = baseEventSchema.shape({
  connection_id: yup.string().required(),
  client_name: yup.string().required(),
  aero_pass_user_uuid: yup.string().required(),
  ...baseDeviceTrackingFields,
});

const dutchiePayAeroSyncOnErrorSchema = baseEventSchema.shape({
  error: yup.string().required(),
  ...baseDeviceTrackingFields,
});

const dutchiePayPreAuthEventSchema = baseEventSchema.shape({
  event_name: yup.string().required(),
  error_type: yup.string().nullable(),
  error_message: yup.string().nullable(),
  ...baseDeviceTrackingFields,
});

const baseInstoreCartSchema = baseEventSchema.shape({
  instore_cart_id: yup.string().required(),
  checkout_token: yup.string().nullable(),
  is_kiosk_order: yup.boolean().required(),
  is_hub_order: yup.boolean().required(),
});

const dutchiePayInstoreAccountLinkViewedSchema = baseEventSchema.shape({
  show_barcode: yup.boolean().required(),
});

const dutchiePayKioskQRCodeModalViewedSchema = baseEventSchema.shape({
  checkout_token: yup.string().required(),
});

const loginNudgeSchema = baseEventSchema.shape({
  action: yup.string().oneOf(['clicked', 'dismissed', 'viewed']).required(),
});

const roundupForCharityViewedSchema = baseEventSchema;
const roundupForCharityToggledSchema = baseEventSchema.shape({
  action: yup.string().oneOf(['enabled', 'disabled']).required(),
});

const walletPassSchema = baseEventSchema.shape({
  action: yup.string().oneOf(['clicked', 'dismissed', 'viewed']).required(),
  type: yup.string().oneOf(['qrCode', 'button']).required(),
});

// Instore Enrollment schemas
const instoreEnrollmentStepSchema = baseEventSchema.shape({
  step: yup.string().required(),
});

const instoreEnrollmentStepCompletedSchema = instoreEnrollmentStepSchema;

const medCardSignupCompletedSchema = baseEventSchema.shape({
  waiting_at_dispensary: yup.boolean().required(),
});

const medCardSignupFailedSchema = baseEventSchema.shape({
  error_type: yup.string().required(),
  error_message: yup.string().required(),
});

export const eventsSchema = {
  addedProductToCart: addedProductToCartSchema,
  cartItem: cartItemSchema,
  placedOrder: placedOrderSchema,
  searchResults: searchResultsSchema,
  productClicked: productClickedSchema,
  sponsoredBannerImpression: bannerTrackerSchema,
  sponsoredBannerClicked: bannerTrackerSchema,
  sponsoredProductClicked: productTrackerSchema,
  sponsoredProductImpression: productTrackerSchema,
  viewedPage: viewedPageSchema,
  cartViewed: cartViewedSchema,
  viewedProduct: viewedProductSchema,
  removedProductFromCart: removedProductFromCartSchema,
  dispensaryClicked: dispensaryClickedSchema,
  dutchiePayEnrollmentStep: dutchiePayEnrollmentStepSchema,
  dutchiePayEnrollmentButtonClicked: dutchiePayEnrollmentButtonClickedSchema,
  dutchiePayEnrollmentStepCancelled: dutchiePayEnrollmentStepCancelledSchema,
  dutchiePayPlaidOnLoad: dutchiePayPlaidOnLoadSchema,
  dutchiePayPlaidOnEvent: dutchiePayPlaidOnEventSchema,
  dutchiePayPlaidOnSuccess: dutchiePayPlaidOnSuccessSchema,
  dutchiePayPlaidOnExit: dutchiePayPlaidOnExitSchema,
  dutchiePayCTAButtonClicked: dutchiePayCTAButtonClickedSchema,
  dutchiePayRelinkButtonViewed: dutchiePayRelinkButtonViewedSchema,
  dutchiePayRelinkButtonClicked: dutchiePayRelinkButtonClickedSchema,
  dutchiePayAeroSyncOnEvent: dutchiePayAeroSyncOnEventSchema,
  dutchiePayAeroSyncOnLoad: dutchiePayAeroSyncOnLoadSchema,
  dutchiePayAeroSyncOnClose: dutchiePayAeroSyncOnCloseSchema,
  dutchiePayAeroSyncOnSuccess: dutchiePayAeroSyncOnSuccessSchema,
  dutchiePayAeroSyncOnError: dutchiePayAeroSyncOnErrorSchema,
  dutchiePayPreAuthEvent: dutchiePayPreAuthEventSchema,
  dutchiePayInstoreAccountLinkViewed: dutchiePayInstoreAccountLinkViewedSchema,
  dutchiePayInstoreCartViewed: baseInstoreCartSchema,
  dutchiePayInstoreCartApprovalClicked: baseInstoreCartSchema,
  dutchiePayInstoreCartApprovalSucceeded: baseInstoreCartSchema,
  dutchiePayInstoreCartApprovalFailed: baseInstoreCartSchema,
  dutchiePayKioskQRCodeModalViewed: dutchiePayKioskQRCodeModalViewedSchema,
  loginNudge: loginNudgeSchema,
  roundupForCharityViewed: roundupForCharityViewedSchema,
  roundupForCharityToggled: roundupForCharityToggledSchema,
  walletPass: walletPassSchema,
  instoreEnrollmentStepViewed: instoreEnrollmentStepSchema,
  instoreEnrollmentStepCompleted: instoreEnrollmentStepCompletedSchema,
  instoreEnrollmentStepSkipped: instoreEnrollmentStepSchema,
  medCardSignupCompleted: medCardSignupCompletedSchema,
  medCardSignupFailed: medCardSignupFailedSchema,
};

export type Data = {
  type: keyof typeof eventsSchema;
  payload: Record<string, unknown>;
};

export function validateSchema(data: Data): void {
  eventsSchema[data.type].validateSync(data.payload);
}
